import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class AiSettingsService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
    private baseUrl = 'api/aiSettings';

    constructor(private http: Http) {}

    private extractData(res: any) {
        return res.json() || [];
    }

    getSettings(): Promise<any> {
        return this.http.get(`${this.baseUrl}/getSettings`)
            .toPromise().then(this.extractData).catch(this.handleError);
    }

    save(data: any): Promise<any> {
        return this.http.post(`${this.baseUrl}/save`, $.param(data), { headers: this.headers })
            .toPromise().then(res => res.json()).catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/aiSettings.service.ts